export default "__VITE_ASSET__DFDY1hGe__"